export default from './SavingsMinimumQuestion';



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/SavingsMinimumQuestion/index.js